<div class="card overflow-hidden mt-6 supervision-table">
  <!-- En-tête standard de tableau : recherche uniformisée + bascule Bâtiments/Équipements -->
  <base-data-table-header
    [canCreate]="false"
    [canImport]="false"
    [loading]="loading"
    (onSearchChange)="onSearchChange($event)"
    (onClearTextFilter)="onSearchChange('')"
    [templates]="[{ template: metrikToggle, position: 2, place: 'before' }]"
  ></base-data-table-header>

  <ng-template #metrikToggle>
    <div class="seg flex flex-row ltr:mr-4 rtl:ml-4">
      <button
        type="button"
        [class.on]="metrikType === DefaultSupervisionMetrikTypeEnum.BUILDING"
        (click)="setMetrikType(DefaultSupervisionMetrikTypeEnum.BUILDING)"
      >
        <mat-icon>domain</mat-icon>
        Bâtiments
      </button>
      <button
        type="button"
        [class.on]="metrikType === DefaultSupervisionMetrikTypeEnum.EQUIPMENT"
        (click)="setMetrikType(DefaultSupervisionMetrikTypeEnum.EQUIPMENT)"
      >
        <mat-icon>precision_manufacturing</mat-icon>
        Équipements
      </button>
    </div>
  </ng-template>

  <mat-progress-bar *ngIf="loading" mode="indeterminate" color="primary"></mat-progress-bar>

  <!-- Tableau arborescent : même rendu que les tableaux standards de l'application (mat-table) -->
  <table *ngIf="!loading" mat-table [dataSource]="rows" class="w-full shadow-none">
    <ng-container matColumnDef="node">
      <th mat-header-cell *matHeaderCellDef class="w-2/5">Nœud</th>
      <td mat-cell *matCellDef="let row" class="text-secondary">
        <div class="flex flex-row items-center gap-2 row-label">
          <ng-container *ngIf="row.level === 2">
            <button
              mat-icon-button
              class="caret"
              *ngIf="hasChildren(row)"
              (click)="toggleExpand(row)"
              [attr.aria-label]="'Déplier ' + row.node.label"
            >
              <mat-icon>{{ isExpanded(row) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <span class="caret-placeholder" *ngIf="!hasChildren(row)"></span>
            <mat-icon class="node-ico">{{ nodeIcon(row.node) }}</mat-icon>
          </ng-container>
          <span class="indent" *ngIf="row.level === 3"></span>
          <span class="label">{{ row.node.label }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="contact">
      <th mat-header-cell *matHeaderCellDef class="w-1/4">Acteur Supervision métier</th>
      <td mat-cell *matCellDef="let row" class="text-secondary">
        <ng-container *ngIf="row.node.assignable; else notAssignable">
          <div
            *ngIf="displayedContact(row.node) as contact; else noContact"
            class="who flex flex-row items-center gap-3"
            [class.inherited]="!row.node.ownContact"
          >
            <span class="avatar" [style.background]="avatarColor(contact)">{{ contactInitials(contact) }}</span>
            <span class="name">{{ contactName(contact) }}</span>
          </div>
          <ng-template #noContact>
            <div class="who empty flex flex-row items-center gap-3">
              <span class="avatar ghost"></span>
              Aucun acteur
            </div>
          </ng-template>
        </ng-container>
        <ng-template #notAssignable>
          <span class="not-assignable">Affectation impossible à ce niveau</span>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="provenance">
      <th mat-header-cell *matHeaderCellDef class="w-1/4">Provenance</th>
      <td mat-cell *matCellDef="let row" class="text-secondary">
        <span *ngIf="provenance(row) as prov" class="badge" [ngClass]="prov.kind">
          <mat-icon>
            {{
              prov.kind === 'own'
                ? 'push_pin'
                : prov.kind === 'parent'
                  ? 'subdirectory_arrow_right'
                  : prov.kind === 'tenant'
                    ? 'corporate_fare'
                    : 'warning_amber'
            }}
          </mat-icon>
          {{ prov.label }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" class="text-secondary">
        <div class="actions" *ngIf="row.node.assignable">
          <button
            mat-icon-button
            [permissionBlock]="modifyPermissions"
            [matTooltip]="displayedContact(row.node) ? 'Modifier le contact par défaut' : 'Affecter un contact'"
            (click)="editNode(row.node)"
          >
            <mat-icon>{{ displayedContact(row.node) ? 'edit' : 'person_add' }}</mat-icon>
          </button>
          <button
            *ngIf="row.node.ownContact"
            mat-icon-button
            class="danger"
            [permissionBlock]="modifyPermissions"
            matTooltip="Retirer l'affectation"
            (click)="clearNode(row.node)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="hover:bg-hover trans-ease-out text-secondary font-medium custom-tr"
      [class.lvl2]="row.level === 2"
      [class.lvl3]="row.level === 3"
      [class.row-disabled]="!row.node.assignable"
    ></tr>
  </table>

  <div *ngIf="!loading && rows.length === 0" class="empty-state">Aucun nœud ne correspond aux filtres.</div>
</div>
